import {Injectable} from '@angular/core';
import {ApiService} from './api.service';
import {Network} from "../model/network.model";
import {retryAfterMillis} from "../shared/constants";

@Injectable({providedIn: 'root'})
export class NetworkService {

  private networks: Network[] = [];

  constructor(private apiService: ApiService) {
    this.load();
  }

  load() {
    this.apiService.get('networks')
      .subscribe(dtos => {
        let networks: Network[] = [];
        for (const dto of dtos) {
          networks.push({
            id: dto.id,
            name: dto.name,
            icon: dto.name.toLowerCase()
          });
        }
        this.networks = networks;
      }, err => {
        this.apiService.error({}, err);
        setTimeout(() => this.load(), retryAfterMillis);
      });
  }

  getNetworks() {
    return this.networks;
  }
}
